'use client';

import {
  ChakraProvider,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  VStack,
} from '@chakra-ui/react';
import { fallbackTheme } from 'styles/theme';

const Loading = () => {
  return (
    <ChakraProvider theme={fallbackTheme}>
      {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
      <Modal isOpen size="full" onClose={() => {}} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent h="full">
          <ModalBody>
            <VStack align="center" justify="center" h="full">
              <Spinner
                size="lg"
                speed="0.75s"
                color="blue.800"
                thickness="2px"
              />
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
};

export default Loading;
